import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

export const Section: React.FC<sharedComponents.Section> = ({ bgColor, children, className }) => (
  <div className={classNames(styles.outerContainer, bgColor && { [styles[bgColor]]: true })}>
    <div className={classNames(styles.innerContainer, className)}>
      {children}
    </div>
  </div>
);
